/* The Finer Things Market — hover to turn.
   Move the mouse across a product card and it flips through that product's
   photos, left to right, like turning it in your hand. Not a true 360 --
   that needs photos shot at every angle -- but every view the product has.
   Mouse only: on a phone the card swipes and taps as it always did. */
(() => {
  if (window.__finerSpin) return;
  window.__finerSpin = true;
  if (!matchMedia('(pointer: fine)').matches) return;

  const MAX = 12;
  const products = new Map();   // handle -> Promise<string[] image urls>
  const frames = new Map();     // handle -> Promise<string[] display urls (staged where possible)>

  const handleOf = card => {
    const a = card.querySelector('a[href*="/products/"]');
    const m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  };
  const imagesFor = handle => {
    if (!products.has(handle)) {
      products.set(handle, fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}products/${handle}.js`, { headers: { Accept: 'application/json' } })
        .then(r => (r.ok ? r.json() : null))
        .then(p => (p && Array.isArray(p.images) ? p.images.slice(0, MAX).map(u => (u.startsWith('//') ? 'https:' + u : u)) : []))
        .catch(() => []));
    }
    return products.get(handle);
  };
  const framesFor = handle => {
    if (!frames.has(handle)) {
      frames.set(handle, imagesFor(handle).then(urls => {
        const api = window.__finerStageAPI;
        return Promise.all(urls.map(u => {
          const src = api ? api.sized(u, 700) : u;
          // Staged cutout where the shot is on white; the photo itself otherwise.
          return (api ? api.cutout(src, 700) : Promise.resolve(null)).then(blob => ({ url: blob || src, staged: !!blob }))
            .then(f => new Promise(res => { const im = new Image(); im.onload = () => res(f); im.onerror = () => res(null); im.src = f.url; }));
        })).then(list => list.filter(Boolean));
      }));
    }
    return frames.get(handle);
  };

  let active = null;   // { card, media, layer, img, dots, list, idx }
  // Never change the card while a button is down: WebKit drops a click whose press and
  // release land on a page that changed in between.
  let pressed = false; const afterRelease = [];
  addEventListener('pointerdown', () => { pressed = true; }, true);
  addEventListener('pointerup', () => { pressed = false; afterRelease.splice(0).forEach(f => f()); }, true);
  const whenReleased = f => (pressed ? afterRelease.push(f) : f());
  const leave = () => {
    if (!active) return;
    const a = active; active = null;
    a.card.classList.remove('fn-spinning');
    a.layer.classList.remove('on');
    setTimeout(() => { if (!a.card.classList.contains('fn-spinning')) a.layer.remove(); }, 450);
  };
  const show = (a, i) => {
    if (!a.list.length || i === a.idx) return;
    a.idx = i;
    const f = a.list[i];
    a.img.src = f.url;
    a.layer.classList.toggle('staged', f.staged);
    a.dots.querySelectorAll('i').forEach((d, k) => d.classList.toggle('on', k === i));
  };

  document.addEventListener('pointerover', e => {
    const card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card || (active && active.card === card)) return;
    leave();
    const media = card.querySelector('.card__media .media, .card__media');
    const handle = handleOf(card);
    if (!media || !handle) return;
    const layer = document.createElement('div');
    layer.className = 'fn-spin'; layer.setAttribute('aria-hidden', 'true');
    // The hint shows on a visitor's first few hovers only.
    let seen = 0; try { seen = +sessionStorage.getItem('fnSpinHint') || 0; sessionStorage.setItem('fnSpinHint', String(seen + 1)); } catch (_) {}
    layer.innerHTML = '<img alt=""><div class="fn-spin-dots"></div>' + (seen < 3 ? '<span class="fn-spin-hint">Move to turn</span>' : '');
    active = { card, media, layer, img: layer.querySelector('img'), dots: layer.querySelector('.fn-spin-dots'), list: [], idx: -1 };
    const mine = active;
    framesFor(handle).then(list => {
      if (active !== mine || list.length < 2) return;
      whenReleased(() => {
        if (active !== mine) return;
        mine.list = list;
        mine.dots.innerHTML = list.map(() => '<i></i>').join('');
        media.appendChild(layer);          // only now, with its views ready
        card.classList.add('fn-spinning');
        show(mine, 0);
        requestAnimationFrame(() => layer.classList.add('on'));
      });
    });
  }, { passive: true });

  document.addEventListener('pointermove', e => {
    if (!active || !active.list.length) return;
    const r = active.media.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) {
      if (!active.card.contains(e.target)) leave();
      return;
    }
    const px = (e.clientX - r.left) / r.width;
    show(active, Math.min(active.list.length - 1, Math.max(0, Math.floor(px * active.list.length))));
  }, { passive: true });
  document.addEventListener('pointerout', e => {
    if (active && !active.card.contains(e.relatedTarget)) leave();
  }, { passive: true });

  // Warm the cache for cards that come on screen, a few at a time, so the
  // first hover is instant -- product JSON only; frames load on first hover.
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { io.unobserve(en.target); const h = handleOf(en.target); if (h) imagesFor(h); } }), { rootMargin: '200px' });
    const scan = root => root.querySelectorAll('.card-wrapper').forEach(c => { if (!c.dataset.fnSpinSeen) { c.dataset.fnSpinSeen = '1'; io.observe(c); } });
    scan(document);
    new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => { if (n.nodeType === 1 && n.querySelectorAll) scan(n); }))).observe(document.body, { childList: true, subtree: true });
  }
})();
